import MarkdownPreview from '@uiw/react-markdown-preview';

const source = `
## Child Sexual Abuse and Exploitation (CSAE) Policy

**Introduction**

Interacto is committed to providing a safe and positive experience for all users. We have a zero-tolerance policy for any form of Child Sexual Abuse and Exploitation (CSAE). This policy outlines our commitment to preventing, detecting, and responding to CSAE content and behavior within our app.

**Definition of CSAE**

CSAE includes any content or behavior that:

* Depicts, promotes, or facilitates child sexual abuse or exploitation.
* Involves real or simulated sexual exploitation of minors.
* Encourages grooming or solicitation of minors for sexual purposes. 
* Shares or distributes images, videos, or other media of child sexual exploitation.

**Prohibited Content and Behavior**

We strictly prohibit:

* **Sharing, uploading, or distributing any media that depicts CSAE.** This includes images, videos, or any other form of content that sexually exploits, abuses, or endangers children.
* **Soliciting, grooming, or engaging in communication with minors for sexual purposes.** This includes any attempt to engage in sexual conversations, or to meet a minor for sexual purposes.
* **Inappropriate interactions between adults and minors that could lead to exploitation.** This includes any behavior that could be construed as predatory or harmful to a child, such as excessive attention or inappropriate gifts.
* **Any content that sexualizes minors, even if the content is fictional or generated.** This includes content that portrays or encourages the sexualization of children in any way.
* **Any attempt to use the app to facilitate CSAE activities or networks.** This includes any attempt to distribute, promote, or connect with others who engage in CSAE activities.

**Prevention Measures**

* **User Education:** We provide clear and accessible guidelines for all users on appropriate behavior and content within the app. These guidelines are readily available within the app itself and on our website.
* **Content Moderation:** We employ a combination of automated and manual moderation systems to proactively detect and remove CSAE content. This includes using AI-powered tools and human moderators to review user-generated content.
* **Age Verification:** We implement age-verification mechanisms to ensure that users comply with applicable age restrictions.
* **Reporting Mechanisms:** We provide easy-to-use reporting mechanisms within the app for users to flag any suspected cases of CSAE. Reports are promptly reviewed by our moderation team.

**Detection and Response**

* **Proactive Monitoring:** Our moderation team actively monitors user activity and content within the app for any signs of CSAE.
* **User Reports:** We take all user reports of suspected CSAE seriously and investigate them thoroughly.
* **Cooperation with Law Enforcement:** We cooperate fully with law enforcement agencies in the investigation and prosecution of CSAE offenses. We report any suspected cases of child exploitation to the National Center for Missing & Exploited Children (NCMEC) and other relevant authorities.
* **Data Preservation:** We preserve relevant data to assist in law enforcement investigations.

**User Support and Resources**

* We provide resources and support for users who have been affected by CSAE, including links to relevant organizations that can offer assistance.
* We encourage users to seek help if they are concerned about the online safety of a child. 

**Compliance and Review**

We regularly review and update this policy to ensure it complies with all applicable laws and regulations related to child safety. 

**Contact**

If you have any questions or concerns about this policy, please contact us at [Your Email Address]

**Disclaimer:** This is a sample policy and may need to be adapted to meet the specific requirements of your app and applicable laws in your region. 

**Note:**

* This is a sample policy and should be reviewed and adapted by legal counsel to ensure it complies with all applicable laws and regulations in your jurisdiction. 
* It is crucial to have a robust system in place for handling reports of CSAE, including a dedicated team to investigate and respond to such reports. 
* Regularly review and update your CSAE policy to reflect any changes in laws, regulations, or best practices.

By implementing a comprehensive CSAE policy and adhering to these guidelines, you can help to create a safer online environment for all users of your app.
`;

export default function ChildSafetypolicy() {
  return <>
    <MarkdownPreview source={source}/>
  </>
}
